/** Referenced here https://github.com/ejrbuss/markdown-to-txt/blob/main/src/markdown-to-txt.ts */

import marked from "marked";
import { escape, unescape } from "lodash-es";

const block = (text) => text + "\n\n";
const escapeBlock = (text) => escape(text) + "\n\n";
const line = (text) => text + "\n";
const inline = (text) => text;
const newline = () => "\n";
const empty = () => "";

const TEXT_RENDERER = {
  // Block elements
  code: escapeBlock,
  blockquote: block,
  html: empty,
  heading: block,
  hr: newline,
  list: (text) => block(text.trim()),
  listitem: line,
  checkbox: empty,
  paragraph: block,
  table: (header, body) => line(header + body),
  tablerow: (text) => line(text.trim()),
  tablecell: (text) => text + " ",
  // Inline elements
  strong: inline,
  em: inline,
  codespan: inline,
  br: newline,
  del: inline,
  link: (_0, _1, text) => text,
  image: (_0, _1, text) => text,
  text: inline,
  // etc.
  options: {}
};

/**
 * Converts markdown to plaintext using the marked Markdown library.
 * Accepts [MarkedOptions](https://marked.js.org/using_advanced#options) as
 * the second argument.
 *
 * NOTE: The output of markdownToTxt is NOT sanitized. The output may contain
 * valid HTML, JavaScript, etc. Be sure to sanitize if the output is intended
 * for web use.
 *
 * @param markdown the markdown text to txtify
 * @param options  the marked options
 * @returns the unmarked text
 */
export function markdownToText(markdown, options) {
  const unmarked = marked(markdown, { ...options, renderer: TEXT_RENDERER });
  const unescaped = unescape(unmarked);
  const trimmed = unescaped.trim();
  return trimmed;
}

export function getTextFromMarkdown(md) {
  /** if last char is space or a new line removing that and adding temp char */
  if (!md) return "";
  if (/\s$|\n$/.test(md)) {
    md = md.slice(0, -1);
    md = md + ".";
  }

  /** convert line break to spaces to preserve it */
  md = md.replace(/\n/g, " ");

  const text = markdownToText(md);
  return text;
}
